module.exports = __webpack_public_path__ + "img/thermometer-title.ceb14228.png";